<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, watch, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useMarketsStore } from '@/stores/markets';
import { useGeneralStore } from '@/stores/general';
import { useSocketStore } from '@/stores/socket';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import HighlightsFixtureContainer from '@/components/pre_sports/highlights/HighlightsFixtureContainer.vue';
import FixtureOrderSelector from '@/components/pre_sports/highlights/FixtureOrderSelector.vue';
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import { useFavouritesStore } from '@/stores/favourites';

const { t } = useI18n();

const router = useRouter();
const route = useRoute();
const preSportsStore = usePreSportsStore();
const marketsStore = useMarketsStore();
const generalStore = useGeneralStore();
const socketStore = useSocketStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();
const favouritesStore = useFavouritesStore();

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);
const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);
const selected_fixture_order = ref('popular');
const show_scroll_to_top_button = ref(false);

const sportId = computed(() => {
	return Number(route.params.sport_id);
});

const timeParam = computed(() => {
	return route.params.from;
});

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
};

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
};

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
};

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
};

const loadOverviewMarkets = (sId) => {
	if (!sId) return;
	let sport_overview_markets = marketsStore.sportOverviewMarkets(sId);
	if (sport_overview_markets && sport_overview_markets.length > 0) {
		if (sport_overview_markets.length > 1) {
			primary_overview_market.value = sport_overview_markets[0];
			secondary_overview_market.value = sport_overview_markets[1];
		} else {
			primary_overview_market.value = sport_overview_markets[0];
			secondary_overview_market.value = sport_overview_markets[0];
		}
	}
};

const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};

const scrollToTop = () => {
	window.scrollTo({ top: 0 });
};

onMounted(() => {
	if (sportId.value) {
		loadOverviewMarkets(sportId.value);


		let selected_pre_sport = _.find(preSportsStore.preSports, { 'id': sportId.value });
		if (selected_pre_sport) {
			document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.competitions');
		}
	}
	window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {

	window.removeEventListener('scroll', handleScroll);
});

watch(() => marketsStore.overview_markets, () => {
	loadOverviewMarkets(sportId.value);
});

watch(() => route.params.sport_id, (newSportId) => {
	if (newSportId) {
		let numId = Number(newSportId);
		loadOverviewMarkets(numId);
	}
});
</script>

<template>
	<div class="live-bet-dashboard round-games-main set_game-outer">
		<div class="bet-dashboard-top">
			<!-- Primary Overview Market Dropdown -->
			<div class="tabing-dashboard">

			</div>
			<div class="dashboard-info-label bet-tab-title" >

			</div>

			<div class="dashboard-info-label dropdown-option-top" v-if="primary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_primary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
						<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
							<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_primary_overview_market = !show_primary_overview_market" v-click-outside-element="closePrimaryOverviewMarketSelector">
								{{ primary_overview_market?.name?.toUpperCase() }}
							</button>
						</dt>
						<dd>
							<ul>
								<li v-for="overview_market in marketsStore.sportOverviewMarkets(sportId)" :key="overview_market.slug" @click="selectPrimaryOverviewMarket(overview_market)" :class="primary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
									<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market?.name?.toUpperCase() }}</button>
									<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(sportId, overview_market)">
										<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
											<path :style="{ fill: favouritesStore.isOverviewFavourite(sportId, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
										</svg>
									</div>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>

			<!-- Secondary Overview Market Dropdown -->
			<div class="dashboard-info-label dropdown-option-top dropdown-option-top-2" v-if="secondary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_secondary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
						<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
							<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_secondary_overview_market = !show_secondary_overview_market" v-click-outside-element="closeSecondaryOverviewMarketSelector">
								{{ secondary_overview_market?.name?.toUpperCase() }}
							</button>
						</dt>
						<dd>
							<ul>
								<li v-for="overview_market in marketsStore.sportOverviewMarkets(sportId)" :key="overview_market.slug" @click="selectSecondaryOverviewMarket(overview_market)" :class="secondary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
									<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market?.name?.toUpperCase() }}</button>
									<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(sportId, overview_market)">
										<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
											<path :style="{ fill: favouritesStore.isOverviewFavourite(sportId, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
										</svg>
									</div>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>

			<!-- Fixture Order Selector (Popular / Time) -->
			<FixtureOrderSelector v-model="selected_fixture_order" />

			<!-- Mobile Odds Heading -->
			<div class="mobile-odds-heading">
				<div class="mobile-odds-heading-inner">
					<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
						<span v-if="odd != ''">{{ odd }}</span>
					</template>
				</div>
			</div>
		</div>

		<!-- Highlights Fixture Container -->
		<div class="live-tab-info" id="tabs">
			<HighlightsFixtureContainer
				v-if="primary_overview_market"
				:primary_overview_market="primary_overview_market"
				:secondary_overview_market="secondary_overview_market"
				:sport_id="sportId"
				:time="timeParam"
				:competition_ids="route.params.competition_ids"
				:fixture_order="selected_fixture_order"
				:pre_only="false"
			/>
		</div>
	</div>

</template>

<style scoped>
.live-bet-dashboard .dashboard-info-label .select-option .drop dd ul {
	min-width: 120px;
}
.live-bet-dashboard.round-games-main .bet-dashboard-top {
	grid-template-columns: 38% 25% 20% 12%;
}
</style>

<!-- Non-scoped: ::-webkit-scrollbar pseudo-elements don't work with Vue scoped styles -->
<style>
/* Custom scrollbar for fixtures list */
#tabs.live-tab-info {
	max-height: calc(100vh - 180px);
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-width: thin;
	scrollbar-color: var(--primary) transparent;
}

#tabs.live-tab-info::-webkit-scrollbar {
	width: 5px;
}

#tabs.live-tab-info::-webkit-scrollbar-track {
	background: transparent;
	border-radius: 10px;
}

#tabs.live-tab-info::-webkit-scrollbar-thumb {
	background: var(--primary);
	border-radius: 10px;
}

#tabs.live-tab-info::-webkit-scrollbar-thumb:hover {
	background: color-mix(in srgb, var(--primary) 80%, white);
}

#tabs.live-tab-info::-webkit-scrollbar-button {
	display: none !important;
	width: 0 !important;
	height: 0 !important;
}
</style>
